module.exports = __webpack_public_path__ + "img/bg_bottom.9dde43c1.svg";